import React from 'react'
import * as Errors from '@morningtrain/react-errors'
import { SmartviewMount } from '@morningtrain/react-smartviews'
import SmartviewContainer from 'widgets/smartviews/SmartviewContainer'

export default function WithSmartviewLayout (props) {
  return (
    <div className='flex'>
      <div className='flex-col flex-grow overflow-x-auto p-6 sm:px-12 sm:py-8'>
        <Errors.Boundary>
          {props.children}
        </Errors.Boundary>
      </div>
      <SmartviewMount container={SmartviewContainer} />
    </div>
  )
}
